import { render, staticRenderFns } from "./EditCityDialog.vue?vue&type=template&id=72caf310&scoped=true&"
import script from "./EditCityDialog.vue?vue&type=script&lang=js&"
export * from "./EditCityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72caf310",
  null
  
)

export default component.exports